import {Component} from 'react';
import {Link, Navigate} from "react-router-dom";
import config from "../config.json";

class Login extends Component {

    constructor(props) {
        super(props);
        this.state = {
            email: null,
            goToRegister: false
        };
        this.login = this.login.bind(this);
    }

    login = (event) => {
        event.preventDefault();

        const formdata = new FormData();
        formdata.append("email", this.state.email);

        const requestOptions = {
            method: 'POST',
            body: formdata,
            redirect: 'follow',
            credentials: 'include'
        };

        fetch(config.serverUrl_local + `/wine/authenticate`, requestOptions
        ).then(async response => {
            // check for error response
            if (!response.ok) {
                // get error message from body or default to response statusText
                // const error = (data && data.message) || response.statusText;
                this.setState({goToRegister: true})
                // return Promise.reject(error);
            } else {
                const data = await response.json();
                this.setState({author: data});
            }
        })
            .catch(error => {
                this.setState({errorMessage: error.toString()});
                console.error('There was an error!', error);
            });
    }

    render() {
        return <>
            {this.state.author && (
                <Navigate to="/wine-list" replace={true}/>
            )}
            {this.state.goToRegister && (
                <Navigate to="/register" replace={true}/>
            )}
            <div className="container">
                <div className="d-flex flex-column align-items-center justify-content-center  vh-100">
                    {/*<div className="h2 m-5">Le vin est un voyage</div>*/}
                    <fieldset className="fieldset-custom border p-3">
                        <div className="header-logo align-bottom">
                            <legend className="w-auto">Le vin est un voyage</legend>
                        </div>
                        {/*<legend className="w-auto">Le vin est un voyage</legend>*/}
                        <form onSubmit={this.login} className="form-login form-width">
                            <div className="">
                                <label className="form-label display-start m-2" htmlFor="email">E-mail</label>
                                <input type="text" className="form-control form-control-lg border-form" id="email"
                                       onChange={event => this.setState({email: event.target.value})}
                                       placeholder="Entrez votre e-mail"/>

                            </div>
                        </form>
                        <div className="m-3">
                            <button onClick={event => this.login(event)} className="btn btn-primary m-2">Enregistrez vous...</button>
                        {/*    <Link to="register" className="btn btn-secondary  m-2">Enregistrez vous...</Link>*/}
                        </div>
                        <div className="m-1">
                            <a href="mailto:contact@laleph.com">Besoin d’aide?</a>
                        </div>
                    </fieldset>
                </div>
            </div>
        </>
    }
}

export default Login